import { createAction } from 'redux-actions'

export const setOpenAlertsCounts = createAction('SET_OPEN_ALERTS_COUNTS')
